import { render } from "./YogaView.vue?vue&type=template&id=07cc9754&scoped=true"
import script from "./YogaView.vue?vue&type=script&lang=js"
export * from "./YogaView.vue?vue&type=script&lang=js"

import "./YogaView.vue?vue&type=style&index=0&id=07cc9754&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07cc9754"]])

export default __exports__